import axios from "axios";
import notification from "./notifications";
import store from "../store";
import { findDeepProp } from "./helpers";
import Qs from "qs";

const serverNotRespondingMessage = (status) => {
  return `Our server is not responding (${status}), please try again later,
if the problem persists call the system administrator.`;
};

const axiosPlugin = {};
const headers = {};

// Program all Axios defaults here
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || "/api";

axios.defaults.paramsSerializer = (params) =>
  Qs.stringify(params, { arrayFormat: "indices" });
axios.defaults.headers.common = headers;

/**
 * SETTING UP SOME INTERCEPTORS
 */
axios.interceptors.request.use(axiosPlugin.request);
axios.interceptors.response.use(null, axiosPlugin.responseError);

// Error controller
const defaultResponseController = (error) => {
  // If a list of errors is found, we join them and then display the result.
  const dataErrors = findDeepProp("response.data.errors", error);
  if (dataErrors !== null) {
    if (Object.keys(dataErrors).length > 0) {
      let errors = "";
      for (let field in dataErrors) {
        errors += `${dataErrors[field].join("\n")},`;
      }
      notification.warning(errors.slice(0, -1), { duration: 10000 });
      return;
    }
  }

  // if a message is found, we display it.
  const dataMessage = findDeepProp("response.data.message", error);
  if (typeof dataMessage === "string") {
    notification.warning(dataMessage);
    return;
  }

  // Ignore (for now) status code 404
  const dataStatus = findDeepProp("response.status", error);
  if (dataStatus === 404) {
    const method = findDeepProp("response.config.method", error);
    if (["post", "put"].indexOf(method) !== -1) {
      notification.error(serverNotRespondingMessage(dataStatus));
    }
    return;
  }

  // Server error for status codes 500+
  if (dataStatus >= 500) {
    notification.error(serverNotRespondingMessage(dataStatus));
    return;
  }

  console.error(error);

  return;
};

export default {
  install: (Vue, { store }) => {
    Vue.prototype.$axios = axios;
    Vue.prototype.$defaultResponseController = defaultResponseController;

    store.$axios = axios;
    store.$defaultResponseController = defaultResponseController;
  },
};
